import { gql, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useGeneralSoContext } from 'src/common/context';
import { GetTermsAndConditionsFromFilesQuery } from '../types/types';

const GET_TERMS_AND_CONDITIONS_FILES_QUERY = gql(`
 query getTermsAndConditionsFromFiles($id: String!) {
  getTermsAndConditionsFromFiles(id: $id) {
    brandName
    brandCode
    documents {
      fileId
    fileName
    }
  }
}
`);

export function useGetTermsAndConditionsFromFiles() {
  const { offerId } = useGeneralSoContext();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  const { data, loading, error, refetch } = useQuery<GetTermsAndConditionsFromFilesQuery>(GET_TERMS_AND_CONDITIONS_FILES_QUERY, {
    variables: { id: offerId },
    skip: !offerId,
    fetchPolicy: 'network-only'
  });

  const isLoading = !isInitialized || loading;

  return {
    termsAndConditions: offerId ? data?.getTermsAndConditionsFromFiles : undefined,
    loading: isLoading,
    error,
    refetch,
    offerId
  };
}
